import React, { useState } from 'react';
import {
  Dialog,
  Box,
  Typography,
  IconButton,
  DialogContent,
  Grid,
  TextField,
  Button,
  Autocomplete,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const labelStyle = {
  marginBottom: '4px',
  fontWeight: 500,
  color: '#1A1F36',
  fontSize: '14px',
};

const inputStyle = {
  height: '40px',
  backgroundColor: '#fff',
  fontSize: '13px',
  color:'#1A1F36',
};

const countries = ['India', 'United States', 'Canada', 'Australia'];
const states = ['Delhi', 'Maharashtra', 'Karnataka', 'California', 'New York'];

const AddCardDetailsModal = ({ open, onClose, onSave }) => {
  const [expiry, setExpiry] = useState('');
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null); 
  const [cardNumber, setCardNumber] = useState("");
    const [cardName, setCardName] = useState(""); 
    const [cvv, setCvv] = useState("");
  
    const handleSubmit = () => {
      if (cardNumber && cardName && expiry && cvv) {
        onSave({ cardNumber, cardName, expiry, cvv });
        setCardNumber("");
        setCardName("");
        setExpiry("");
        setCvv("");
        onClose();
        
      }
    };
  

  // Auto-format expiration date MM/YY
  // const handleExpiryChange = (e) => {
  //   let value = e.target.value.replace(/\D/g, ''); // only digits
  //   if (value.length > 4) value = value.slice(0, 4); // max 4 digits (MMYY)

  //   if (value.length >= 3) {
  //     value = value.slice(0, 2) + '/' + value.slice(2);
  //   }
  //   setExpiry(value);
  // };

  return (
    <Dialog
     open={open} onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '16px',
          border: '4px solid #00AAE7',
        },
      }}
    >
      {/* Header */}
      <Box sx={{ position: 'relative', borderBottom: '1px solid #DFDFDF', pb: 2 }}>
        <Typography sx={{ px: 3, pt: 2, fontSize: '22px', color: '#1A1F36', fontWeight: 'bold' }}>
        Add Card Details
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton> 
      </Box>

      {/* Content */}
      <DialogContent dividers sx={{ maxHeight: '550px', overflowY: 'auto' }}>
        <Grid container spacing={2}>
          {/* Card Number */}
          <Grid size={{xs:12, md:12,}}>
            <Typography sx={labelStyle}>Card Number*</Typography>
            <TextField
              fullWidth
              placeholder="Card Number"
              value={cardNumber}
              onChange={(e) => setCardNumber(e.target.value)}
              variant="outlined"
              InputProps={{ sx: inputStyle }}
            />
          </Grid>

          {/* Expiration Date & Security Code */}
          <Grid size={{xs:12, md:6,}}>
            <Typography sx={labelStyle}>Expiration Date*</Typography>
            <TextField
              fullWidth
              placeholder="MM/YY"
              variant="outlined"
              value={expiry}
              onChange={(e) => setExpiry(e.target.value)}
              InputProps={{ sx: inputStyle }}
            />
          </Grid>
          <Grid size={{xs:12, md:6,}}>
            <Typography sx={labelStyle}>Security Code*</Typography>
            <TextField
              fullWidth
              placeholder="CVV"
              variant="outlined"
              value={cvv}
              onChange={(e) => setCvv(e.target.value)}
              InputProps={{ sx: inputStyle }}
            />
          </Grid>

          {/* Name on Card */}
          <Grid  size={{xs:12, md:12,}}>
            <Typography sx={labelStyle}>Name on Payment Method*</Typography>
            <TextField
              fullWidth
              placeholder="Name on Card"
              value={cardName}
              onChange={(e) => setCardName(e.target.value)}
              variant="outlined"
              InputProps={{ sx: inputStyle }}
            />
          </Grid>

          {/* Billing Address */}
          <Grid size={{xs:12, md:12,}}>
            <Typography sx={labelStyle}>Billing Address*</Typography>
            <TextField
              fullWidth
              placeholder="Street Address"
              variant="outlined"
              InputProps={{ sx: inputStyle }}
            />
          </Grid>

          {/* Country & City */}
          <Grid size={{xs:12, md:6,}}>
            <Typography sx={labelStyle}>Country*</Typography>
            <Autocomplete
              options={countries}
              value={country}
              onChange={(e, newValue) => setCountry(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select Country"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    sx: inputStyle,
                  }}
                  sx={{ '& .MuiInputBase-input': { fontSize: '13px' } }}
                />
              )}
            />
          </Grid>
          <Grid size={{xs:12, md:6,}}>
            <Typography sx={labelStyle}>City*</Typography>
            <TextField
              fullWidth
              placeholder="City"
              variant="outlined"
              InputProps={{ sx: inputStyle }}
            />
          </Grid>

          {/* State & Zip */}
          <Grid size={{xs:12, md:6,}}>
            <Typography sx={labelStyle}>State*</Typography>
            <Autocomplete
              options={states}
              value={state}
              onChange={(e, newValue) => setState(newValue)}
              renderInput={(params) => (
                <TextField
                  {...params}
                  placeholder="Select State"
                  variant="outlined"
                  InputProps={{
                    ...params.InputProps,
                    sx: inputStyle,
                  }}
                  sx={{ '& .MuiInputBase-input': { fontSize: '13px' } }}
                />
              )}
            />
          </Grid>
          <Grid size={{xs:12, md:6,}}>
            <Typography sx={labelStyle}>Zip Code*</Typography>
            <TextField
              fullWidth
              placeholder="Zip Code"
              variant="outlined"
              InputProps={{ sx: inputStyle }}
            />
          </Grid>
        </Grid>
      </DialogContent>

      {/* Footer Buttons */}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2, p: 2, background:'#F2F6F9', }}>
        <Button
           
          variant="outlined"
          sx={{ borderRadius: '8px', textTransform: 'none', px: 3 }}
        >
          Cancel
        </Button>
        <Button
          variant="contained" onClick={handleSubmit}
          sx={{ borderRadius: '8px', textTransform: 'none', px: 3, backgroundColor: '#0B57D0' }}
        >
          Save
        </Button>
      </Box>
    </Dialog>
  );
};

export default AddCardDetailsModal;
